import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { baseTheme } from '../assets';

// stacks
import WebLoginStack from '../stacks/WebLoginStack';

function WebLoginNavigator() {
  return (
    <NavigationContainer theme={baseTheme}>
      <WebLoginStack />
    </NavigationContainer>
  );
}

export default WebLoginNavigator;
